import { useEffect, useState } from 'react';
import { useMoralis } from 'react-moralis';
import { toast, ToastContainer } from 'react-toastify';
import { PresaleABI } from '../../../data/ABI';
import { inChainId } from '../../../data/chainId';
import { PresaleContract } from '../../../utility/contractAddress';
import { LoaderSpinner } from '../../atoms';
import './ClaimComponent.scss';
const ClaimComponent = ({detail}) => {
  const { Moralis, user } = useMoralis()
  const [detailUser, setdetailUser] = useState('')
  const [loading, setLoading] = useState(false)
  const [hashTrxClaim, setHashTrxClaim] = useState('')

  useEffect(() => {
    const getUserInfo = async () => {
      const web3 = await Moralis.enableWeb3();
      if (user) {
        const walletAddress = await user.get("ethAddress");
        const chainIdDec = await web3.eth.getChainId();
        if (parseInt(inChainId) === parseInt(chainIdDec)) {
          // let stabcontract = new web3.eth.Contract(PresaleABI, detail.tokenAddress);
          let stabcontract = new web3.eth.Contract(PresaleABI, PresaleContract);
          const infouser = await stabcontract.methods.fundersProperty(walletAddress).call();
          setdetailUser(infouser)
        } else {
          console.log("Connect to BSC Network!");
        }
      }
    }
    getUserInfo()
  }, [setdetailUser])
  const claim = async (value) => {
    let user = Moralis.User.current();
    try {
      setLoading(true)
      const walletAddress = user.get("ethAddress");
      const web3 = await Moralis.enableWeb3();
      const chainIdDec = await web3.eth.getChainId();
      if (parseInt(inChainId) === parseInt(chainIdDec)) {
        // let stabcontract = new web3.eth.Contract(PresaleABI, detail.tokenAddress);
        let stabcontract = new web3.eth.Contract(PresaleABI, PresaleContract);
        if (value === 0) {
          stabcontract.methods.Claim_40pct().send(
            {
              from: walletAddress,
              value: 0,
            },
            function (err, res) {
              if (err) {
                console.log("An error occured", err);
                toast.error("Transaction failed!")
                setLoading(false)
                return;
              }
              if (res) {
                toast.success("Second claim success!")
                setHashTrxClaim(res)
                setLoading(false)
              }
            }
          );
        }
        if (value === 1) {
          stabcontract.methods.Claim_20pct_1().send(
            {
              from: walletAddress,
              value: 0,
            },
            function (err, res) {
              if (err) {
                console.log("An error occured", err);
                toast.error("Transaction failed!")
                setLoading(false)
                return;
              }
              if (res) {
                toast.success("Second claim success!")
                setHashTrxClaim(res)
                setLoading(false)
              }
            }
          );
        }
        if (value === 2) {
          stabcontract.methods.Claim_20pct_2().send(
            {
              from: walletAddress,
              value: 0,
            },
            function (err, res) {
              if (err) {
                console.log("An error occured", err);
                toast.error("Transaction failed!")
                setLoading(false)
                return;
              }
              if (res) {
                toast.success("Third claim success!")
                setHashTrxClaim(res)
                setLoading(false)
              }
            }
          );
        }
        if (value === 3) {
          stabcontract.methods.Claim_20pct_3().send(
            {
              from: walletAddress,
              value: 0,
            },
            function (err, res) {
              if (err) {
                toast.error("Transaction failed!")
                setLoading(false)
                return;
              }
              if (res) {
                toast.success("Fourth claim success!")
                setLoading(false)
                setHashTrxClaim(res)
              }
            }
          );
        }
        return;
      } else {
        setLoading(false)
        console.log("Connect to BSC Network!");
      }
    } catch (error) {
      setLoading(false)
      console.log(error);
    }
  }

  return (
    <div className="claim">
      <div className="container">
        <div className="wrapper">
          <div className="row">
            <div className="col-lg-8">
              <span className="title-claim">NEXT CLAIM ROUNDS</span>
              <div className="val-item">
                <span className="d-block subtitle">Available</span>
                <span className="val-info">{detailUser?.reservedToken / 10 ** 18} {detail.symbol}</span>
              </div>
              {
                hashTrxClaim && (
                  <small className="d-block mt-3 text-primary text-center">
                    <a href={`https://testnet.bscscan.com/tx/${hashTrxClaim}`} target="_blank" rel="noopener noreferrer">Check Transaction</a>
                  </small>
                )
              }
            </div>
            <div className="col-lg-4">
              {
                loading && <LoaderSpinner />
              }
              <div className="btn-wrapper">
                <div className="claim-item d-flex">
                  <button onClick={() => claim(0)} className="btnClaim">CLAIM</button>
                  <div className="time-available">00:00:00</div>
                </div>
                <div className="claim-item d-flex">
                  <button onClick={() => claim(1)} className="btnClaim">CLAIM</button>
                  <div className="time-available">00:00:00</div>
                </div>
                <div className="claim-item d-flex">
                  <button onClick={() => claim(2)} className="btnClaim">CLAIM</button>
                  <div className="time-available">00:00:00</div>
                </div>
                <div className="claim-item d-flex">
                  <button onClick={() => claim(3)} className="btnClaim">CLAIM</button>
                  <div className="time-available">00:00:00</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover />
    </div>
  )
}

export default ClaimComponent
